import React from 'react';
import { sortableElement, sortableHandle } from 'react-sortable-hoc';
import { useMediaQuery } from 'react-responsive';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

import GragIcon from '../../../../assets/icons/drag.svg';
import { NameProduct, Name, ImagePreviewProduct } from './SortableItem.styles';
import { IconDragCategories } from '../../../Collection/Collection.styles';

const DragHandle = sortableHandle(() => <ListItemIcon style={{ minWidth: 30 }}><IconDragCategories src={GragIcon} /></ListItemIcon>);

const SortableItem = sortableElement(
    ({ value, iconAction, id, i, handleItemClick, dataImage }) => {
    const isMobile = useMediaQuery({ query: '(max-width: 600px)' });

    return (
        <ListItem ContainerComponent="div" alignItems="center" style={isMobile ? { paddingLeft: 8, paddingRight: 48 } : undefined}>
            <DragHandle />
            {!isMobile && <span style={{ padding: '0 15px', lineHeight: 1 }}>{i + 1}. </span>}
            {dataImage &&
                <ImagePreviewProduct key={i} src={process.env.REACT_APP_IMAGES_API_URL + 'fit-in/600x600/' + dataImage}>
                </ImagePreviewProduct>
            }
            {!iconAction && <NameProduct style={isMobile ? { fontSize: 14 } : undefined}>{value}</NameProduct>}
            {iconAction && <Name style={isMobile ? { fontSize: 14 } : undefined}>{value}</Name>}

            <ListItemSecondaryAction onClick={() => handleItemClick(i, id)}>
                <IconButton
                    edge="end" >
                    {iconAction && <img src={iconAction} alt="" />}
                    {!iconAction && <CloseIcon />}
                </IconButton>
            </ListItemSecondaryAction>
        </ListItem>
    );
}
);

export default SortableItem;